<!--
 * @Date: 2020-08-26 15:44:01
 * @Author: MX
 * @LastEditTime: 2024-07-12 14:57:05
 * @Description: 登录
-->
<template>
  <div class="login">
    <video class="video-box" style="" @contextmenu.prevent id="bannerVideo" src="./login.mp4" disablePictureInPicture="true" controlslist="nodownload nofullscreen noremoteplayback" autoplay loop muted></video>
    <div class="login-box">
      <div class="iconBox">
        <i class="iconfont iconjitulogo_fanbai"></i>
      </div>
      <div class="title">
        极兔开放平台
      </div>
      <div class="form">
        <el-form
          ref="loginForm"
          :model="loginForm"
          :rules="rules"
          autocomplete="off"
          class="login-form"
        >
          <el-form-item prop="account">
            <el-input
              placeholder="请输入账号或手机号"
              maxlength="40"
              v-model.trim="loginForm.account"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_yonghuming"
                :class="loginForm.account && 'red_color'"
              ></i>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              :type="isShowPassword ? 'text' : 'password'"
              maxlength="18"
              v-model.trim="loginForm.password"
            >
              <i
                slot="prefix"
                class="iconfont icondengluzhuce_mima"
                :class="loginForm.password && 'red_color'"
              ></i>
              <i
                slot="suffix"
                class="iconfont pointer"
                :class="[
                  isShowPassword
                    ? 'icondenglu_ico_mimakeshi'
                    : 'icondenglu_ico_mimayincang',
                ]"
                @click="toggleIcon"
              ></i>
            </el-input>
          </el-form-item>
          <div class="remember">
            <el-checkbox
              v-model="remember"
              label="记住账号"
              class="remember-account"
            ></el-checkbox>
          </div>
          <div class="agreement">
            <el-checkbox
              v-model="agreement"
              @change="isAgreementChange"
            ></el-checkbox>
            <p style="padding-left: 10px;">
              我已阅读并接受<span class="agreement-click" @click="agreementClick">《极兔开放平台注册使用协议》</span>和<span class="agreement-click" @click="privacyClick">《隐私政策》</span>
            </p>
          </div>
          <el-button
            class="commonBtn loginBtn"
            :disabled="!loginForm.account || !loginForm.password || !agreement"
            @click.prevent="loginClick"
            :loading="loginLoading"
            >登 录</el-button
          >
          <div class="register-forget">
            <span class="register pointer" @click="goRegister">注册用户</span>
            <span class="forget pointer" @click="forgetPassword">忘记密码</span>
          </div>
          <!-- <div class="software-serve">
            <img src="@/assets/images/register/software-serve313.png" alt="">
          </div> -->
        </el-form>
      </div>
    </div>
    <el-dialog title="用户协议" :visible.sync="userAggrementVisible" class="agreement-dialog" :close-on-click-modal="false" :show-close="false" width="1200px" :close-on-press-escape="false"	 top="50px" center>
      <articlesOfAgreement class="content"></articlesOfAgreement>
      <span slot="footer">
        <el-button type="primary" @click="userAggrementVisible = false">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="隐私政策-中国" :visible.sync="privacyPolicyVisible" class="agreement-dialog" :close-on-click-modal="false" :show-close="false" width="1200px" :close-on-press-escape="false"	 top="50px" center>
      <privacyPolicy class="content"></privacyPolicy>
      <span slot="footer">
        <el-button type="primary" @click="privacyPolicyVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import * as Api from '@/api'
import { RULES } from '@/constants/rules'
import { RESPONSE_SUCCESS } from '@/constants'
import { mapActions } from 'vuex'
// import '@/assets/js/TCaptcha'
import { AESUtil } from '@/utils/'
import articlesOfAgreement from "./components/ArticlesOfAgreement";
import privacyPolicy from "./components/PrivacyPolicy";
export default {
  name: 'Login',
  props: {},
  components: { articlesOfAgreement, privacyPolicy },
  data() {
    return {
      loginForm: {
        account: '',
        password: '',
      },
      loginLoading: false,
      remember: false,
      agreement: false,
      rules: {
        account: [RULES.account],
        password: [RULES.password, RULES.checkPassword],
      },
      isShowPassword: false, //不显示
      captcha:"",//腾讯验证码
      userAggrementVisible: false,
      privacyPolicyVisible: false
    }
  },
  created() {
    this.init()
  },
  mounted(){
    this.initTencentCaptcha();
  },
  methods: {
    ...mapActions(['LOGIN_INIT', 'LOGIN_INIT_APPID']),
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword
      console.log(this.isShowPassword)
    },
    init() {
      // 在页面加载时从cookie获取登录信息
      const account = this.getCookie('account')
      const prd1 = this.getCookie('prd1')
      const prd2 = this.getCookie('prd2')
      const prd3 = this.getCookie('prd3')
      const password = AESUtil.aesDecrypt(prd1.substring(0, 3) + prd2.substring(0, 3) + prd3)

      // 如果存在赋值给表单，并且将记住密码勾选
      if (account) {
        this.loginForm.account = account
        this.loginForm.password = password
        this.remember = true
      }
    },
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      this.captcha = new window.TencentCaptcha('2033367267', this.tencentCaptchaCallback, { forceLang: 'zh-cn' });
      // 显示验证码
      // this.captcha.show()
    },
      // 验证码回调
    async tencentCaptchaCallback(res) {
      console.log('腾讯验证码回调：callback', res);
      // 验证成功，返回对象
      if (res.ret === 0) {
        // 定义参数：票据 随机字符串
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr
        }
        // 调用登陆
        this.login(customParams)
        return res
      }
      // 验证不成功
      return null
    },
    agreementClick() {
      this.userAggrementVisible = true
    },
    isAgreementChange(flag) {
      if (flag) {
        this.privacyPolicyVisible = true
      }
    },
    privacyClick() {
      this.privacyPolicyVisible = true
    },
    loginClick(){
      //防止 登录后再次操作
      this.captcha && !this.loginLoading?this.captcha.show():this.$message.warning('网络出错，请刷新后尝试！')
    },
    /**
     * @description 登录
     */
    async login(customParams) {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true
          const { account, password } = this.loginForm;
          Api.login({account, password: AESUtil.aesEncrypt(password),...customParams}).then((res) => {
            this.loginLoading = true
            if (res.code === RESPONSE_SUCCESS) {
              // this.loginLoading = false
              this.LOGIN_INIT({ user: res.data, token: res.data.token })
              this.getAppList()
              this.$router.push({ path: sessionStorage.getItem('lastRouter') !== '/register' ? sessionStorage.getItem('lastRouter') : '/' })

              // 保存用户账号信息到cookie
              this.saveAccountCookie(AESUtil.aesEncrypt(password)) // 记住密码
            } else {
              this.loginLoading = false
              this.$message.error(res.msg)
              localStorage.setItem('YL_TOKEN', '')
              localStorage.setItem('appId', '')
            }
          }).catch((err)=>{
            this.loginLoading = false
            console.log(err, '======================err')
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    /**
     * @description 应用列表数据
     */
    async getAppList() {
      const { code, data, msg } = await this.$API.appList()
      if (code === RESPONSE_SUCCESS) {
        this.LOGIN_INIT_APPID({ appId: data[0].id })
      } else {
        this.$message.error(msg)
      }
    },
    /**
     * @description 保存用户名密码
     */
    saveAccountCookie(pwd) {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      const { account } = this.loginForm
      if (this.remember) {
        // if (this.getCookie('password') === password) return
        let num1 = '';
        let num2 = '';
        for (var i = 0;i < 5;i++) {
          num1 += Math.floor(Math.random() * 10);
          num2 += Math.floor(Math.random() * 10);
        }
        const prd1 = pwd.length >= 3 ? (pwd.substring(0, 3) + num1) : pwd.substring(0, 3)
        const prd2 = pwd.length >= 6 ? (pwd.substring(3, 6) + num2) : pwd.substring(3, 6)
        const prd3 = pwd.substring(6)
        this.setCookie('account', account, 7 * 24 * 3600)
        this.setCookie('prd1', prd1, 7 * 24 * 3600)
        this.setCookie('prd2', prd2, 7 * 24 * 3600)
        this.setCookie('prd3', prd3, 7 * 24 * 3600)
      } else {
        this.setCookie('account', '')
        this.setCookie('prd1', '')
        this.setCookie('prd2', '')
        this.setCookie('prd3', '')
      }
    },
    // 获取cookie
    getCookie(key) {
      const cookie = document.cookie
      const length = cookie.length
      if (length) {
        let start = cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          let end = cookie.indexOf(';', start)
          if (end === -1) end = length
          return unescape(cookie.substring(start, end))
        }
      }
      return ''
    },
    // 保存cookie
    setCookie(cName, value, expireseconds) {
      const exdate = new Date()
      exdate.setTime(exdate.getTime() + expireseconds * 1000)
      document.cookie =
        cName +
        '=' +
        decodeURIComponent(value) +
        (expireseconds == null ? '' : ';expires=' + exdate.toGMTString())
    },
    forgetPassword() {
      this.$router.push({ path: '/forgetPassword' })
    },
    goRegister() {
      this.$router.push({ path: '/register' })
    },
  },
}
</script>

<style lang="scss" scoped>
.agreement-dialog {
  ::v-deep .el-dialog__header {
    background-color: #333;
    opacity: 0.5;
    padding: 20px 0;
    .el-dialog__title {
      color: #ffffff;
      font-size: 2em;
      font-weight: bold;
    }
  }
  ::v-deep .el-dialog__body {
    overflow: auto;
    height: calc(100vh - 294px);
  }
}
  .video-box {
    position: absolute;
    width: auto;
    height: 100vh;
    top: 64px;
    left: 0;
  }

.login {
  height: 100vh;
  overflow: hidden;
  min-width: 1200px;
  //background: $theme-color url('../../assets/images/register/background.png')
  //  no-repeat 80px center;
  //background-size: 53%;
  position: relative;
  font-family: PingFang, PingFang-SC;
  .software-serve{
    margin: 60px auto;
    margin-bottom: 0;
    text-align: center;
  }
  .login-box {
    position: absolute;
    top: 46%;
    right: 140px;
    width: 520px;
    height: 546px;
    background: rgba(255, 255, 255, 0.5); /* 设置背景颜色为白色，透明度为 0.5 */
    backdrop-filter: blur(10px); /* 模糊半径设为 10 像素 */
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    padding: 50px 100px 0px;
    box-sizing: border-box;
    transform: translateY(-50%);
    .iconBox {
      text-align: center;
      .iconjitulogo_fanbai {
        font-size: 31px;
        line-height: 31px;
        color: $theme-color;
      }
    }
    .title {
      width: 360px;
      font-size: 20px;
      text-align: center;
      color: $theme-color;
      line-height: 20px;
      letter-spacing: 40px;
      margin-top: 40px;
      font-weight: 600;
    }
    .form {
      margin-top: 30px;
      .iconfont {
        font-size: 20px;
      }
      .icondengluzhuce_yonghuming,
      .icondengluzhuce_mima {
        &.red_color {
          color: $theme-color;
        }
      }
      .loginBtn {
        width: 320px;
        height: 54px;
        //background: $theme-color;
        //border-color: $theme-color;
        //color: #fff;
        font-size: 18px;
      }
      .remember {
        margin-bottom: 20px;
        .remember-account {
          line-height: 18px;
        }
      }
      .agreement {
        display: flex;
        font-size: 13px;
        .agreement-click {
          cursor: pointer;
          color:$theme-color;
        }
      }
      .register-forget {
        font-size: 14px;
        color: $theme-color;
        margin-top: 20px;
        .forget {
          float: right;
        }
      }
    }
  }
}
.login::v-deep {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    height: 50px;
    line-height: 50px;
    .el-input__inner {
      height: 50px;
      line-height: 50px;
    }
  }
  .el-input__prefix {
    left: 10px;
  }
  .el-input:focus-within .iconfont {
    color: $theme-color;
  }

  .el-input--prefix .el-input__inner {
    padding-left: 40px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 40px;
  }
  .el-input__suffix {
    right: 10px;
  }
}

.loginBtn {
  background-image: linear-gradient(to right, #D31027 0%, #EA384D  51%, #D31027  100%);
  margin: 10px;
  padding: 15px 45px;
  text-align: center;
  text-transform: uppercase;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  box-shadow: 0 0 20px #eee;
  border-radius: 10px;
  display: block;
  &.is-disabled:hover {
    background-image: linear-gradient(to right, #D31027 0%, #EA384D 51%, #D31027 100%)
  }
}

.loginBtn:hover {
  background-position: right center !important; /* change the direction of the change here */
  color: #fff !important;
  text-decoration: none !important;
}


</style>
